// extracted by mini-css-extract-plugin
module.exports = {"cardInfo":"PaymentMethods_cardInfo__2ncWB","cardLogo":"PaymentMethods_cardLogo__LaZLu"};